var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner__wrapper__1kzPN.spinner__centered__19TLF.spinner__inline__2B47E {\n  text-align: center;\n}\n.spinner__wrapper__1kzPN.spinner__centered__19TLF > .spinner__spinner__1Qtvp {\n  margin: 0 auto;\n}\n.spinner__wrapper__1kzPN.spinner__inline__2B47E > .spinner__spinner__1Qtvp {\n  display: inline-block;\n  vertical-align: middle;\n}\n.spinner__spinner__1Qtvp {\n  background-image: url(" + escape(require("images/spinner.gif")) + ");\n  background-size: 30px 30px;\n  display: block;\n  height: 30px;\n  width: 30px;\n}\n.spinner__spinner__1Qtvp.spinner__small__36uxd {\n  background-size: 18px 18px;\n  height: 18px;\n  width: 18px;\n}\n.spinner__spinner__1Qtvp.spinner__modLeft__3jNWW {\n  margin-right: 3px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "spinner__wrapper__1kzPN",
	"centered": "spinner__centered__19TLF",
	"inline": "spinner__inline__2B47E",
	"spinner": "spinner__spinner__1Qtvp",
	"small": "spinner__small__36uxd",
	"modLeft": "spinner__modLeft__3jNWW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2072/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/loading/spinner.less
// module id = l2hJ
// module chunks = 1